import {createAction} from 'Shared/utilities/actionCreator';

export enum ValidateActionType {
  VALIDATE_TAX_IDENTIFIER = 'validate/VALIDATE_TAX_IDENTIFIER',
  CHANGE_IS_TAX_IDENTIFIER_VALID = 'validate/CHANGE_IS_TAX_IDENTIFIER_VALID',
}

export const validateTaxIdentifier = (taxIdentifier: string, uniqueKey: string) =>
  createAction(ValidateActionType.VALIDATE_TAX_IDENTIFIER, {taxIdentifier, uniqueKey});
export const changeIsTaxIdentifierValid = (isValid: boolean, uniqueKey: string) =>
  createAction(ValidateActionType.CHANGE_IS_TAX_IDENTIFIER_VALID, {isValid, uniqueKey});

type IsTaxIdentifierValidDict = {
  [uniqueKey: string]: boolean;
};

type ValidateState = {
  isTaxIdentifierValidDict: IsTaxIdentifierValidDict;
};

export const DEFAULT_STATE: ValidateState = {
  isTaxIdentifierValidDict: {},
};

type ValidateAction = ReturnType<typeof changeIsTaxIdentifierValid>;

export default (state: ValidateState = DEFAULT_STATE, action: ValidateAction): ValidateState => {
  switch (action.type) {
    case ValidateActionType.CHANGE_IS_TAX_IDENTIFIER_VALID:
      return {
        ...state,
        isTaxIdentifierValidDict: {
          ...state.isTaxIdentifierValidDict,
          [action.payload.uniqueKey]: action.payload.isValid,
        },
      };
    default:
      return state;
  }
};
